import React from 'react';
import Link from 'next/link';
import { GQLApp } from 'townapps-models';
import Image from 'next/image';
import cn from 'classnames';

const LogosApp = ({ app }: { app: GQLApp }) => {
  if (!app.sponsoredLogo) {
    return null;
  }

  return (
    <div className="w-full overflow-hidden" style={{ marginTop: '60px' }}>
      <div className="ml-auto mr-auto max-w-screen-xl flex w-full flex-col md:flex-row  pt-4 pb-4 md:pt-4 md:pb-4">
        {/* <div className={cn('justify-center mb-4 md:mb-0 md:justify-start items-center flex w-full md:w-2/24 relative')}>
          <Link href={app.sponsoredLogoLink ? app.sponsoredLogoLink : ' ' }>
           <Image className={`md:h-3.5 md:mb-0 h-2.5 mb-8 ${app.sponsoredLogoLink && 'cursor-pointer'}`} objectFit="contain" src={app.sponsoredLogo} width={85} height={60} alt={''} />
           </Link>
        </div> */}

        <div className="flex flex-row md:w-full justify-between"> 

        {app.sponsoredLogo  && (
            <div
              className={cn('flex-1 flex justify-center md:justify-end', {
                'md:mr-8': !!app.firstSponsor || !!app.secondSponsor,
                'mr-2': !!app.firstSponsor || !!app.secondSponsor,
              })}>
                <Link href={app.sponsoredLogoLink ? app.sponsoredLogoLink : '' }>
                  <Image className={`md:h-3.5 md:mb-0 h-2.5 mb-8 ${app.sponsoredLogoLink && 'cursor-pointer'}`} objectFit="contain" src={app.sponsoredLogo} width={85} height={60} alt={''} />
              </Link>
            </div>
          )}


          {app.firstSponsor  && (
            <div
              className={cn('flex-1 flex justify-center md:justify-end', {
                'md:mr-8': !!app.secondSponsor || !!app.thirdSponsor,
                'mr-2': !!app.secondSponsor || !!app.thirdSponsor,
              })}>
                <Link href={app.firstSponsorLink ? app.firstSponsorLink : '' }>
                  <Image className={`md:h-3.5 md:mb-0 h-2.5 mb-8 ${app.firstSponsorLink && 'cursor-pointer'}`} objectFit="contain" src={app.firstSponsor} width={85} height={60} alt={''} />
              </Link>
            </div>
          )}

          {app.secondSponsor && (
            <div
              className={cn('flex-1  flex justify-center md:justify-end', {
                'md:mr-8': !!app.thirdSponsor,
                'mr-2': !!app.thirdSponsor || !!app.fourthSponsor,
              })}>
                <Link href={app.secondSponsorLink ? app.secondSponsorLink : ' ' }>
                  <Image className={`md:h-3.5 md:mb-0 h-2.5 mb-8 ${app.secondSponsorLink && 'cursor-pointer'}`} objectFit="contain" src={app.secondSponsor} width={85} height={60} alt={''} />
              </Link>
            </div>
          )}

          {app.thirdSponsor && (
            <div className={cn('flex-1  flex justify-center md:justify-end', {
              'md:mr-8': !!app.fourthSponsor,
              'mr-2': !!app.fourthSponsor || !!app.fifthSponsor,
            })}>
              <Link href={app.thirdSponsorLink ? app.thirdSponsorLink : ' ' }>
              <Image className={`md:h-3.5 md:mb-0 h-2.5 mb-8 ${app.thirdSponsorLink && 'cursor-pointer'}`} objectFit="contain" src={app.thirdSponsor} width={85} height={60} alt={''} />
              </Link>
            </div>
          )} 
         {app.fourthSponsor && (
            <div
              className={cn('flex-1 flex justify-center md:justify-end', {
                'md:mr-8': !!app.fifthSponsor || !!app.sixthSponsor,
                'mr-2': !!app.fifthSponsor || !!app.sixthSponsor,
              })}>
              <Link href={app.fourthSponsorLink ? app.fourthSponsorLink : ' ' }>
                <Image className={`md:h-3.5 md:mb-0 h-2.5 mb-8 ${app.fourthSponsorLink && 'cursor-pointer'}`} objectFit="contain" src={app.fourthSponsor} width={85} height={60} alt={''} />
              </Link>
            </div>
          )}

           {app.fifthSponsor && (
            <div
              className={cn('flex-1 flex justify-center md:justify-end', {
                'md:mr-8': !!app.sixthSponsor,
                'mr-2': !!app.fourthSponsor || !!app.sixthSponsor,
              })}>
              <Link href={ app.fifthSponsorLink ? app.fifthSponsorLink : ' ' }>
                 <Image className={`md:h-3.5 md:mb-0 h-2.5 mb-8 ${app.fifthSponsorLink && 'cursor-pointer'}`} objectFit="contain" src={app.fifthSponsor} width={85} height={60} alt={''} />
              </Link>
            </div>
          )}
           
           {app.sixthSponsor && (
            <div
              className={cn('flex-1 flex justify-center md:justify-end')}>
                 <Link href={app.sixthSponsorLink ? app.sixthSponsorLink: ' ' }>
              <Image className={`md:h-3.5 md:mb-0 h-2.5 mb-8 ${app.sixthSponsorLink && 'cursor-pointer'}`} objectFit="contain" src={app.sixthSponsor} width={85} height={60} alt={''} />
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LogosApp;
